export const IS_SHIP_RELATED_COLUMN = 'is_ship_related';
export const IS_CERTIFICATE_COLUMN = 'is_certificate';
export const IS_CARGO_COLUMN = 'is_cargo';
export const ENDPOINT_DOCUMENT_UPLOAD = '/documentextrafields/upload';
export const DOC_TYPE_ID_COLUMN = 'doc_type_id';
